import React, { useState, useEffect, useCallback } from 'react';
import apiClient from '../../../api/apiClient';
import LoadingSpinner from '../../../components/ui/LoadingSpinner';
import ErrorBanner from '../../../components/ui/ErrorBanner';
import { st, colors } from '../shared/meetingStyles';
import Avatar from '../shared/Avatar';
import { SmileIcon } from '../shared/Icons';

export default function CheckInSection({ session }) {
  const [attendance, setAttendance] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!session) { setLoading(false); return; }
    setLoading(true);
    setError(null);
    try {
      const res = await apiClient.get(`/meetings/sessions/${session.id}/attendance`);
      setAttendance(res.data.attendance || []);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  }, [session]);

  useEffect(() => { load(); }, [load]);

  const togglePresent = async (userId, present) => {
    await apiClient.put(`/meetings/sessions/${session.id}/attendance/${userId}`, { present: !present });
    await load();
  };

  if (!session) return <div style={st.card}><div style={st.emptyState}><SmileIcon size={28} style={{ color: colors.faint }} />Start the meeting to check in.</div></div>;
  if (loading) return <LoadingSpinner />;

  const presentCount = attendance.filter(a => a.present !== 0 && a.present !== false).length;

  return (
    <div style={st.card}>
      {error && <ErrorBanner message={error} />}
      <div style={st.cardHeader}>
        <h2 style={{ ...st.h2, display: 'flex', alignItems: 'center', gap: '0.5rem' }}><SmileIcon size={18} /> Check-in</h2>
        <span style={st.pill}>{presentCount}/{attendance.length} present</span>
      </div>
      <div style={{
        background: `linear-gradient(135deg, ${colors.primarySoft}, #f5f3ff)`, borderRadius: '0.75rem',
        padding: '0.9rem 1.1rem', marginBottom: '1.1rem', border: `1px solid #e0e7ff`,
      }}>
        <div style={st.eyebrow}>This week's icebreaker</div>
        <div style={{ fontSize: '0.9rem', color: colors.text, fontWeight: '600', fontStyle: 'italic' }}>"{session.icebreaker_question}"</div>
      </div>
      <div style={{ fontSize: '0.8rem', fontWeight: '800', color: colors.text, marginBottom: '0.6rem' }}>Who is present?</div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.6rem' }}>
        {attendance.map(a => {
          const present = a.present !== 0 && a.present !== false;
          return (
            <button key={a.user_id} type="button" onClick={() => togglePresent(a.user_id, a.present)} style={{
              display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.8rem', fontWeight: '600',
              cursor: 'pointer', padding: '0.4rem 0.8rem 0.4rem 0.5rem', borderRadius: '999px',
              border: `1.5px solid ${present ? colors.primary : colors.border}`,
              background: present ? colors.primarySoft : '#fff', color: present ? colors.primaryDark : colors.faint,
              opacity: present ? 1 : 0.65, transition: 'all 0.12s ease',
            }}>
              <Avatar name={a.name} size={22} />
              {a.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
